import React, { useState } from "react";
import axios from "axios";
import "./DataMigration.css";

export default function DataMigration() {
  const [files, setFiles] = useState({
    activeLeads: null,
    droppedLeads: null,
    comments: null,
    deals: null,
  });

  const [isUploading, setIsUploading] = useState(false);
  const [previewData, setPreviewData] = useState(null);
    const [isPreviewing, setIsPreviewing] = useState(false);
    const [activePreviewTab, setActivePreviewTab] = useState("activeLeads");
  const [uploadError, setUploadError] = useState("");
  const [uploadSuccess, setUploadSuccess] = useState("");
  const [batchId, setBatchId] = useState(null);
  const [validationReport, setValidationReport] = useState(null);
  const [isValidating, setIsValidating] = useState(false);

  const allFilesSelected =
    files.activeLeads &&
    files.droppedLeads &&
    files.comments &&
    files.deals;

  const handleFileChange = (key, file) => {
    setFiles((previousFiles) => ({
      ...previousFiles,
      [key]: file || null,
    }));

    /*
      Agar upload hone ke baad koi file replace hoti hai,
      to purana batch reset ho jayega.
    */
    setBatchId(null);
    setUploadSuccess("");
    setUploadError("");
    setValidationReport(null);
  };

  const handleUpload = async () => {
    if (!allFilesSelected) {
      setUploadError("Please select all four CSV files.");
      setUploadSuccess("");
      return;
    }

    try {
      setIsUploading(true);
      setUploadError("");
      setUploadSuccess("");
      setBatchId(null);
      setValidationReport(null);

      const formData = new FormData();

      formData.append("activeLeads", files.activeLeads);
      formData.append("droppedLeads", files.droppedLeads);
      formData.append("comments", files.comments);
      formData.append("deals", files.deals);

      const response = await axios.post(
  "https://aranyaka-crm-backend-production.up.railway.app/api/migration/upload",
  formData,
  {
    timeout: 0,
  }
);

      const uploadedBatchId =
        response.data?.batchId ||
        response.data?.batch?.id ||
        response.data?.data?.batchId;

      if (!uploadedBatchId) {
        throw new Error(
          "Files uploaded, but batch ID was not received from the server."
        );
      }

      setBatchId(uploadedBatchId);
      setUploadSuccess(
        `Files uploaded successfully. Batch ID: ${uploadedBatchId}`
      );
    } catch (error) {
      console.error("Migration upload error:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Unable to upload migration files.";

      setUploadError(errorMessage);
        } finally {
      setIsUploading(false);
    }
  };

  const handleValidate = async () => {
    if (!batchId) {
      return;
    }

    try {
      setIsValidating(true);
      setUploadError("");

      const response = await axios.post(
  "https://aranyaka-crm-backend-production.up.railway.app/api/migration/validate",
        {
          batchId: batchId,
        }
      );

      setValidationReport(response.data.report);

      console.log("Validation Report:");
      console.log(response.data.report);
    } catch (error) {
      console.error(
        "Migration validation error:",
        error
      );

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Validation failed.";

      setUploadError(errorMessage);
    } finally {
      setIsValidating(false);
    }
  };

  const handlePreview = async () => {
  if (!batchId) {
    return;
  }

  try {
    setIsPreviewing(true);
    setUploadError("");
    setPreviewData(null);

    const response = await axios.post(
  "https://aranyaka-crm-backend-production.up.railway.app/api/migration/preview",
  {
    batchId,
  }
);

    const preview = response.data?.preview;

    if (!preview) {
      throw new Error(
        "Preview data was not received."
      );
    }

    setPreviewData(preview);

    const availableFiles = Object.keys(
      preview.files || {}
    );

    if (availableFiles.length > 0) {
      setActivePreviewTab(
        availableFiles[0]
      );
    }

  } catch (error) {
    console.error(error);

    setUploadError(
      error.response?.data?.message ||
      error.message
    );
  } finally {
    setIsPreviewing(false);
  }
};
const handleStartMigration = async () => {
  if (!batchId) {
    return;
  }

  try {
    const response = await axios.post(
      "https://aranyaka-crm-backend-production.up.railway.app/api/migration/start",
      {
        batchId,
      }
    );

    console.log(
      "Migration Start Response:",
      response.data
    );

    if (response.data?.started) {
      alert(
        `Migration started successfully in background.\n\nBatch ID: ${response.data.batchId}\n\nYou can monitor progress in backend logs.`
      );
      return;
    }

    alert(
      response.data?.message ||
      "Migration request submitted successfully."
    );

  } catch (error) {
    console.error(
      "Start migration failed:",
      error
    );

    alert(
      error.response?.data?.message ||
      error.message ||
      "Migration start failed."
    );
  }
};
  return (
    <div className="migration-page">
      <div className="migration-header">
        <h1>Data Migration</h1>

        <p>
          Upload Bytepaper CRM files, validate the data, preview the results
          and start migration.
        </p>
      </div>

      <div className="migration-grid">
        <MigrationCard
          title="Active Leads CSV"
          file={files.activeLeads}
          disabled={isUploading}
          onFileChange={(file) =>
            handleFileChange("activeLeads", file)
          }
        />

        <MigrationCard
          title="Dropped Leads CSV"
          file={files.droppedLeads}
          disabled={isUploading}
          onFileChange={(file) =>
            handleFileChange("droppedLeads", file)
          }
        />

        <MigrationCard
          title="Comments CSV"
          file={files.comments}
          disabled={isUploading}
          onFileChange={(file) =>
            handleFileChange("comments", file)
          }
        />

        <MigrationCard
          title="Deals CSV"
          file={files.deals}
          disabled={isUploading}
          onFileChange={(file) =>
            handleFileChange("deals", file)
          }
        />
      </div>

      {uploadError && (
        <div className="migration-message migration-message-error">
          {uploadError}
        </div>
      )}

      {uploadSuccess && (
        <div className="migration-message migration-message-success">
          <div>
            <strong>Upload completed successfully</strong>
            <span>{uploadSuccess}</span>
          </div>
        </div>
      )}

      <div className="action-bar">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleUpload}
          disabled={!allFilesSelected || isUploading}
        >
          {isUploading ? "Uploading..." : "Upload Files"}
        </button>

        <button
  type="button"
  className="btn"
  onClick={handleValidate}
  disabled={
    !batchId ||
    isUploading ||
    isValidating
  }
>
  {isValidating
    ? "Validating..."
    : "Validate"}
</button>

        <button
  type="button"
  className="btn"
  onClick={handlePreview}
  disabled={
    !batchId ||
    !validationReport ||
    isUploading ||
    isValidating ||
    isPreviewing
  }
>
  {isPreviewing
    ? "Loading Preview..."
    : "Preview"}
</button>

        <button
  type="button"
  className="btn btn-danger"
  onClick={handleStartMigration}
  disabled={
    !batchId ||
    isUploading ||
    isValidating ||
    isPreviewing
  }
>
  Start Migration
</button>
      </div>

      {batchId && (
        <div className="migration-batch-info">
          Current migration batch:
          <strong> #{batchId}</strong>
        </div>
      )}
      {validationReport && (    
  <div className="validation-report">

    <div className="validation-report-header">

      <div>
        <h2>Validation Report</h2>

        <p>
          Batch #{validationReport.batchId}
        </p>
      </div>

      <span className="validation-status">
        {validationReport.status}
      </span>

    </div>

    <div className="validation-summary-grid">

      <ValidationStat
        label="Total Rows"
        value={validationReport.totals.totalRows}
      />

      <ValidationStat
        label="Valid Rows"
        value={validationReport.totals.validRows}
      />

      <ValidationStat
        label="Invalid Rows"
        value={validationReport.totals.invalidRows}
      />

      <ValidationStat
        label="Missing Phones"
        value={validationReport.totals.missingPhones}
      />

      <ValidationStat
        label="Invalid Phones"
        value={validationReport.totals.invalidPhones}
      />

    </div>

        {Array.isArray(validationReport.files) &&
  validationReport.files.length > 0 && (
    <div className="validation-files-section">
      <div className="validation-files-heading">
        <h3>File-wise Validation</h3>

        <p>
          Detailed validation summary for each uploaded CSV file.
        </p>
      </div>

      <div className="validation-files-grid">
        {validationReport.files.map((file) => (
          <ValidationFileCard
            key={file.fileId || file.fileType}
            file={file}
          />
        ))}
      </div>
    </div>
  )}

  </div>
)}

{previewData && (
  <div className="preview-section">

    <div className="preview-header">
      <h2>Migration Preview</h2>

      <p>
        Showing first {previewData.limit} rows from each uploaded CSV.
      </p>
    </div>

    <div className="preview-tabs">

      {Object.keys(previewData.files).map((fileKey) => (

        <button
          key={fileKey}
          type="button"
          className={
            activePreviewTab === fileKey
              ? "preview-tab active"
              : "preview-tab"
          }
          onClick={() =>
            setActivePreviewTab(fileKey)
          }
        >
          {previewData.files[fileKey].originalName}
        </button>

      ))}

    </div>

    <PreviewTable
      file={previewData.files[activePreviewTab]}
    />

  </div>
)}
    </div>
  );
}

function ValidationStat({
  label,
  value,
}) {
  return (
    <div className="validation-stat-card">

      <span>
        {label}
      </span>

      <strong>
        {Number(value).toLocaleString("en-IN")}
      </strong>

    </div>
  );
}

function ValidationFileCard({ file }) {
  const fileTitleMap = {
    activeLeads: "Active Leads",
    droppedLeads: "Dropped Leads",
    comments: "Comments",
    deals: "Deals",
  };

  const title =
    fileTitleMap[file.fileType] ||
    file.originalName ||
    file.fileType ||
    "CSV File";

  return (
    <div className="validation-file-card">
      <div className="validation-file-card-header">
        <div>
          <h4>{title}</h4>

          <p>{file.originalName}</p>
        </div>  

        <span
          className={`validation-file-status ${
            file.status === "valid"
              ? "validation-file-status-valid"
              : "validation-file-status-warning"
          }`}
        >
          {file.status || "checked"}
        </span>
      </div>

      <div className="validation-file-stats">
        <FileValidationStat
          label="Total Rows"
          value={file.totalRows}
        />

        <FileValidationStat
          label="Valid Rows"
          value={file.validRows}
        />

        <FileValidationStat
          label="Invalid Rows"
          value={file.invalidRows}
        />

        <FileValidationStat
          label="Missing Phones"
          value={file.missingPhones}
        />

        <FileValidationStat
          label="Invalid Phones"
          value={file.invalidPhones}
        />

        <FileValidationStat
          label="Missing Names"
          value={file.missingNames}
        />

        <FileValidationStat
          label="Missing Drop Reasons"
          value={file.missingDropReasons}
        />

        <FileValidationStat
          label="Invalid Dates"
          value={file.invalidDates}
        />
      </div>
    </div>
  );
}

function FileValidationStat({
  label,
  value,
}) {
  const numericValue =
    Number(value || 0);

  return (
    <div className="validation-file-stat">
      <span>{label}</span>

      <strong>
        {numericValue.toLocaleString("en-IN")}
      </strong>
    </div>
  );
}
function PreviewTable({ file }) {
  if (!file) return null;

  const headers = file.headers || [];
  const rows = file.rows || [];

  return (
    <div className="preview-table-wrapper">
      <table className="preview-table">
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {headers.map((header) => (
                <td key={header}>
                  {String(row?.[header] ?? "")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
function MigrationCard({
  title,
  file,
  disabled,
  onFileChange,
}) {
  return (
    <div className="migration-card">
      <h3>{title}</h3>

      <label
        className={`file-box${file ? " file-selected" : ""}${
          disabled ? " file-box-disabled" : ""
        }`}
      >
        <div className="file-icon">
          {file ? "✅" : "📄"}
        </div>

        {file ? (
          <>
            <p className="selected-file-name">
              {file.name}
            </p>

            <span className="selected-file-help">
              {disabled
                ? "Upload in progress"
                : "Click to replace this file"}
            </span>
          </>
        ) : (
          <>
            <p>Select CSV File</p>

            <span className="selected-file-help">
              Click to browse
            </span>
          </>
        )}

        <input
          type="file"
          accept=".csv,text/csv"
          disabled={disabled}
          onChange={(event) => {
            const selectedFile =
              event.target.files?.[0] || null;

            onFileChange(selectedFile);

            /*
              Same file ko dobara select karne ke liye
              input value clear kar rahe hain.
            */
            event.target.value = "";
          }}
        />
      </label>
    </div>
  );
}